export default __webpack_public_path__ + "static/media/truck_icon.a47287d3.svg";